import {useEffect} from "react";

export default function useLockBodyScroll(enabled: boolean = true) {
    useEffect(() => {
        if (!enabled || typeof window === "undefined") {
            return;
        }
        if (!window.matchMedia("(max-width: 768px)").matches) {
            return;
        }

        const targets: HTMLElement[] = [document.body];
        if (document.documentElement) {
            targets.push(document.documentElement);
        }
        document.querySelectorAll<HTMLElement>(".page").forEach((el) => targets.push(el));

        const prev = targets.map((el) => el.style.overflow);
        targets.forEach((el) => {
            el.style.overflow = "hidden";
        });

        return () => {
            targets.forEach((el, i) => {
                el.style.overflow = prev[i];
            });
        };
    }, [enabled]);
}
